import { warn } from "@swivl-mono/helpers";
import { NormalQuestInterface } from "@swivl-mono/types";
import React from "react";
import { FaCaretRight, FaCaretUp, FaExclamationTriangle } from "react-icons/fa";

import NodeModel from "../../../Nodes/NodeModel";
import "./IssuesView.scss";

interface ItemProps {
  panToAndSelectNode(node: any): void;
  issue: { node: any; issue: string };
}
export function IssuesViewItem(props: ItemProps) {
  const fixClicked = () => {
    props.panToAndSelectNode(props.issue.node);
  };
  return (
    <div className="issuesViewItem">
      <div className="issueContent">{props.issue.issue}</div>
      <div className="fixButton" onClick={fixClicked}>
        FIX
      </div>
    </div>
  );
}
// export default class IssuesView extends React.Component {
//   constructor(props) {
//     super(props);
//     this.questValidator = new QuestValidator();
//     this.state = { isOpen: false, hasOpened: false };
//     this.toggleOpen = this.toggleOpen.bind(this);
//   }

//   toggleOpen() {
//     this.setState({ isOpen: !this.state.isOpen, hasOpened: true });
//   }

//   componentWillReceiveProps(nextProps) {
//     var isDiff;
//     if (!this.props.selectedQuest && nextProps.selectedQuest) {
//       isDiff = true;
//     }
//     if (this.props.selectedQuest && !nextProps.selectedQuest) {
//       isDiff = true;
//     }
//     if (
//       this.props.selectedQuest &&
//       nextProps.selectedQuest &&
//       this.props.selectedQuest.id &&
//       nextProps.selectedQuest.id &&
//       this.props.selectedQuest.id != nextProps.selectedQuest.id
//     ) {
//       isDiff = true;
//     }
//     if (isDiff) {
//       this.setState({ isOpen: false, hasOpened: false });
//     }
//   }

//   render() {
// if (!this.props.selectedQuest) {
//   return null;
// }
// var self = this;
// var quest = this.props.selectedQuest;
// this.questValidator.validatedAndMarkQuest(quest);
// if (!quest.issues || quest.issues.length === 0) {
//   return null;
// }

// let issues, arrowIcon;
// if (this.state.hasOpened) {
//   issues = quest.issues.map(function (item, index) {
//     return (
//       <IssuesViewItem
//         issue={item}
//         key={item.id}
//         isVisible={self.state.isOpen}
//         panToAndSelectNode={self.props.panToAndSelectNode}
//       />
//     );
//   });
// }
// if (this.state.isOpen) {
//   arrowIcon = <FaCaretUp />;
// } else {
//   arrowIcon = <FaCaretRight />;
// }
// const mainText =
//   quest.issues.length === 1
//     ? "There is an issue with one of your nodes"
//     : "There is an issue with " + quest.issues.length + " of your nodes";
// return (
//   <div className="issuesView" onClick={this.toggleOpen}>
//     {issues}
//     <div className="issuesViewMainContent">
//       {arrowIcon}
//       <FaExclamationTriangle />

//       <div className="issuesViewMainText">{mainText}</div>
//     </div>
//   </div>
//     );
//   }
// }

interface Props {
  quest?: NormalQuestInterface;
  panToAndSelectNode(node: any): void;
}
export default function IssuesView(props: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { panToAndSelectNode, quest } = props;
  if (!quest) {
    return null;
  }
  let invalidNodes: any[] = [];
  for (const key in quest.data) {
    if (Object.prototype.hasOwnProperty.call(quest.data, key)) {
      const node = quest.data[key];
      if (!node.type) {
        warn("Node has no type", node);
      }
      let model = NodeModel.forType(node.type) as any;
      let isInvalid: any = model && model.isInvald ? model.isInvald(node) : null;
      if (isInvalid) {
        invalidNodes.push(isInvalid);
      }
    }
  }

  if (invalidNodes.length === 0) {
    return null;
  }

  const issues =
    isOpen &&
    invalidNodes.map(function (item, index) {
      return <IssuesViewItem issue={item} key={item.node.id} panToAndSelectNode={panToAndSelectNode} />;
    });

  const arrowIcon = isOpen ? <FaCaretUp /> : <FaCaretRight />;
  const mainText =
    invalidNodes.length === 1 ? "There is an issue with one of your nodes" : "There is an issue with " + invalidNodes.length + " of your nodes";
  return (
    <div className="issuesView">
      {issues}
      <div
        className="issuesViewMainContent"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        {arrowIcon}
        <FaExclamationTriangle />

        <div className="issuesViewMainText">{mainText}</div>
      </div>
    </div>
  );
}
